import React, { PureComponent } from 'react';
import { FiX } from 'react-icons/fi';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import ModalBase from '../modal-base';

const Window = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  max-height: 90%;
  width: 85%;
  max-width: 60em;
  margin: 0 auto;
  padding: 1.5em;
  background: white;
  color: #111111;
`;

const Content = styled.div`
  overflow-y: auto;
  flex: 1;
  line-height: 1.5;
  z-index: 1;
`;

const Title = styled.div`
  font-size: 1.5em;
  margin-bottom: 0.8em;
`;

const Close = styled.div`
  cursor: pointer;
  font-size: 2.5em;
  background: black;
  color: white;
  position: absolute;
  width: 1.2em;
  height: 1.2em;
  display: flex;
  align-items: center;
  justify-content: center;
  top: -0.6em;
  right: -0.6em;
`;

class Modal extends PureComponent {
  render() {
    const {
      title,
      onClose,
      showClose,
      children,
      positionalChildren,
      ...rest
    } = this.props;
    return (
      <ModalBase onClose={onClose}>
        <Window {...rest}>
          {showClose && (
            <Close onClick={onClose}>
              <FiX />
            </Close>
          )}
          {title && <Title>{title}</Title>}
          <Content>{children}</Content>
          {positionalChildren}
        </Window>
      </ModalBase>
    );
  }
}

Modal.propTypes = {
  title: PropTypes.node,
  onClose: PropTypes.func.isRequired,
  showClose: PropTypes.bool,
  positionalChildren: PropTypes.node
};

Modal.defaultProps = {
  showClose: true,
  positionalChildren: null
};

export default Modal;
